import { render, staticRenderFns } from "./auditComicCard.vue?vue&type=template&id=575b8278"
import script from "./auditComicCard.vue?vue&type=script&lang=js"
export * from "./auditComicCard.vue?vue&type=script&lang=js"
import style0 from "./auditComicCard.vue?vue&type=style&index=0&id=575b8278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports